import React from "react";
import { FaShareAlt } from "react-icons/fa";
import "./ShareButton.css"

const ShareButton = ()=>{
    const shareData = {
        title: document.title,
        text: "Guarda questa curiosità su 10curiosita.it!",
        url: window.location.href,
    }


const handleShare = async () => {
    if(navigator.share) {
        try {
            await navigator.share(shareData);
        }
        catch (err) {
            console.error("Condivisone annullata o in errore", err);
        }
       }
       else {
        // fallback per desktop
        window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          window.location.href
        )}`,
        "_blank"
        );
       }
    };

    return (
        <button onClick={handleShare} className="share-button">
            <FaShareAlt/> Condividi
        </button>
      );
    };

    export default ShareButton;
